/**
 * Convert HTML into Text and List elements
 */

export const parseHtml = (html: string) => {
  // Strip out tags and exclude any text between <ul></ul>
  const text = html
    .replace(/<ul>.*?<\/ul>/g, "")
    .replace(/<b>/g, "")
    .replace(/<\/b>/g, "")
    .trim();
  // Extract list
  const listItems =
    html
      .match(/<li>(.*?)<\/li>/g)
      ?.map(item => item.replace(/<\/?li>/g, "").trim()) || [];

  return {
    text,
    listItems,
  };
};
